import React, { useState } from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Done as DoneIcon, SkipNext as SkipNextIcon, Cancel as CancelIcon, Visibility } from '@mui/icons-material';
import { Colors } from '../../../assets/theme/Colors';
import ToDoAlertMap from './ToDoAlertMap';
import { getRescueDropoffAddress, getRescuePickupAddress } from '../../../helpers/RescuesHelper';

const ToDoAlertCard = ({
  rescue,
  type,
  onRemoveClick,
  onSkipClick,
  onReviewClick,
  current = false,
  next = false,
  content = '',
  unclaimed = false,
  notReviewable = false,
  reviewLabel = 'Review',
  isConfirm = false,
}) => {
  const [cardOut, setCardOut] = useState();
  const animationTime = 300;

  const handleCardOut = () => setCardOut(true);

  return (
    <Box
      boxShadow={3}
      sx={[
        {
          position: 'relative',
          backgroundColor: '#fff',
          width: '100%',
          height: '100%',
          borderRadius: '16px',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 3,
          marginBottom: 3,
          transition: 'transform 0.2s ease-in',
          zIndex: 10,
          display: current || next ? 'block' : 'none',
        },
        next && {
          position: 'absolute',
          top: 0,
          zIndex: 5,
          transform: 'translateX(10px) translateY(10px)',
          maxHeight: 'fit-content',
        },
        cardOut && {
          transform: 'translateX(-120%) rotate(-5deg) translateY(20px)',
          transition: 'all 0.3s ease-in',
        },
      ]}
    >
      <Box sx={{ paddingTop: 3, paddingRight: 2, paddingLeft: 2 }}>
        <Typography sx={{ textAlign: 'center' }} variant="h6">
          {type}
        </Typography>
        <Box my={1} sx={{ minHeight: unclaimed ? '112px' : '' }}>
          <Typography variant="subtitle1">{content}</Typography>
        </Box>
        <Box mb={2}>
          <ToDoAlertMap
            pickupAddress={rescue ? getRescuePickupAddress(rescue.details) : null}
            dropoffAddress={rescue ? getRescueDropoffAddress(rescue.details) : null}
          />
        </Box>
      </Box>
      <Grid container>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            sx={[
              {
                textTransform: 'none',
                padding: '2px',
                paddingTop: '5px',
                fontSize: '16px',
                width: '100%',
                borderRadius: 0,
              },
              {
                borderBottomLeftRadius: '16px',
              },
            ]}
            onClick={() => {
              if (current) {
                onRemoveClick(rescue, handleCardOut, animationTime);
              }
            }}
          >
            <span
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {isConfirm ? (
                <>
                  <DoneIcon sx={{ color: Colors.green.light, fontSize: '32px' }} />
                  Confirm
                </>
              ) : (
                <>
                  <CancelIcon sx={{ color: Colors.red, fontSize: '32px' }} />
                  Remove
                </>
              )}
            </span>
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            sx={{
              textTransform: 'none',
              padding: '2px',
              paddingTop: '5px',
              fontSize: '16px',
              width: '100%',
              borderRadius: 0,
            }}
            onClick={() => {
              if (current) {
                setCardOut(true);
                setTimeout(() => {
                  onSkipClick();
                }, animationTime);
              }
            }}
          >
            <span
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <SkipNextIcon sx={{ color: '#ec9a29', fontSize: '32px' }} />
              Skip
            </span>
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            sx={[
              {
                textTransform: 'none',
                padding: '2px',
                paddingTop: '5px',
                fontSize: '16px',
                width: '100%',
                borderRadius: 0,
              },
              {
                borderBottomRightRadius: '16px',
              },
            ]}
            onClick={() => {
              if (current && notReviewable) {
                return onRemoveClick(rescue, handleCardOut, animationTime);
              }

              if (current) {
                return onReviewClick(rescue, handleCardOut, animationTime);
              }

              return null;
            }}
          >
            <span
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {isConfirm ? (
                <>
                  <Visibility sx={{ color: Colors.blue.light, fontSize: '32px' }} />
                  {reviewLabel}
                </>
              ) : (
                <>
                  <DoneIcon sx={{ color: Colors.green.light, fontSize: '32px' }} />
                  {reviewLabel}
                </>
              )}
            </span>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ToDoAlertCard;
